import { Component, NgZone, OnInit, Input, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CompanyElement } from '../models/company.model';
import { CompanyService } from '../services/company.service';
import { LanguageService } from '../services/language.service';
import { MenusComponent } from './../menus/menus.component';
import { AppComponent } from './../app.component';
import { DialogService } from '../services/dialog.service';
import { TranslocoService } from '@jsverse/transloco';
import { environment } from './../../environments/environment';
import { filter } from 'rxjs';
import { StorageService } from '../services/storage.service';

const API_URL = environment.API_URL
@Component({
  selector: 'app-company',
  templateUrl: './company.component.html',
  styleUrl: './company.component.css'
})

export class CompanyComponent implements OnInit {

  constructor(public ngZone: NgZone, private router: Router, private route: ActivatedRoute,
              private companyService: CompanyService, private menusComponent: MenusComponent,
              private dialogService: DialogService, private appComponent: AppComponent, 
              private langService: LanguageService, private translocoService: TranslocoService,
              public storageService: StorageService) { }

  public titleCompany = "Compañía";
  public new = false;
  @Input() id: number=0;

  item: any = [];
  imgUrl: any = "";
  imageBase64 = "";
  hasLogo = false;

  filename="";

  name_Input:string="";
  address_line_1_Input:string="";
  address_line_2_Input:string="";
  city_Input:string="";
  country_Input:string="";
  first_contact_person_name_Input:string="";
  first_contact_person_email_Input:string="";
  first_contact_person_phone_Input:string="";
  emergency_contact_person_name_Input:string="";
  emergency_contact_person_email_Input:string="";

  company: CompanyElement = {
    id: 0,
    name: '',
    address_line_1: '',
    address_line_2: '',
    city: '',
    country: '',
    first_contact_person_name: '',
    first_contact_person_email: '',
    first_contact_person_phone: '',
    emergency_contact_person_name: '',
    emergency_contact_person_email: '',
    hasLogo: "",
    logo: '',
  };
  
  ngOnInit(): void {
    this.route.queryParams.
      subscribe(params => {
        this.id = (params['id']);
      });

    const currentLang = this.langService.getLang();
      if(this.id > 0){
      this.new = false
      
      this.translocoService.selectTranslate('company.titleEdit')
      .subscribe((translatedTitle: string) => {
        this.titleCompany = translatedTitle;
      });
      
      this.imgUrl = `${API_URL}/companies/` + this.id + `/logo`

      //GET
      const req=this.companyService.getCompanyById(this.id);
      req.subscribe({
        next: (res) => {
          this.item = res;
          if(this.item.data != null){
            this.name_Input = this.item.data.name;
            this.address_line_1_Input = this.item.data.address_line_1;
            this.address_line_2_Input = this.item.data.address_line_2;
            this.city_Input = this.item.data.city;
            this.country_Input = this.item.data.country;
            this.first_contact_person_name_Input = this.item.data.first_contact_person_name;
            this.first_contact_person_email_Input = this.item.data.first_contact_person_email;
            this.first_contact_person_phone_Input = this.item.data.first_contact_person_phone;
            this.emergency_contact_person_name_Input = this.item.data.emergency_contact_person_name;
            this.emergency_contact_person_email_Input = this.item.data.emergency_contact_person_email;
            this.hasLogo = this.item.data.has_logo=="1"
          }
        },
        error: (e) => {
          console.error(e);
          let msg = e.error.message;
        },
      });

    }else{
      this.new = true
      this.translocoService.selectTranslate('company.titleNew')
      .subscribe((translatedTitle: string) => {
        this.titleCompany = translatedTitle;
      });
    }
  }

  onGuardarItm(){
    let msg:string="";
    if (this.new ){
      //ADD
      this.company ={
        id: 0,
        name: this.name_Input,
        address_line_1: this.address_line_1_Input,
        address_line_2: this.address_line_2_Input,
        city: this.city_Input,
        country: this.country_Input,
        first_contact_person_name: this.first_contact_person_name_Input,
        first_contact_person_email: this.first_contact_person_email_Input,
        first_contact_person_phone: this.first_contact_person_phone_Input,
        emergency_contact_person_name: this.emergency_contact_person_name_Input,
        emergency_contact_person_email: this.emergency_contact_person_email_Input,
        hasLogo: "",
        logo: this.imageBase64
      }
      this.companyService.addCompany(this.company)
      .subscribe({
        next: (res) => {
          msg = res.message;
          console.log(msg);
          this.msgDialog(msg, '', true, 'O');
        },
        error: (e) => {
          msg = e.error.message;
          console.error(e);
          this.msgDialog('ERROR', msg, false, 'E');
        },
      });
    }else{
       //UPDATE
      this.company ={
        id: this.id,
        name: this.name_Input,
        address_line_1: this.address_line_1_Input,
        address_line_2: this.address_line_2_Input,
        city: this.city_Input,
        country: this.country_Input,
        first_contact_person_name: this.first_contact_person_name_Input,
        first_contact_person_email: this.first_contact_person_email_Input,
        first_contact_person_phone: this.first_contact_person_phone_Input,
        emergency_contact_person_name: this.emergency_contact_person_name_Input,
        emergency_contact_person_email: this.emergency_contact_person_email_Input,
        hasLogo: "",
        logo: this.imageBase64
      }
      this.companyService.updateCompany(this.id , this.company)
      .subscribe({
        next: (res) => {
          msg = res.message;
          console.log(msg);
          this.msgDialog(msg, '', true, 'O');
        },
        error: (e) => {
          msg = e.error.message;
          console.error(e);
          this.msgDialog('ERROR', msg, false, 'E');
        },
      });
    }
  }

  msgDialog(msgShow:string, msg2Show:string, isOK:boolean, type:string){
    this.dialogService.confirmDialog({
      title: 'Empresa',
      message: msgShow,
      message2: msg2Show,
      confirmText: 'OK',
      cancelText: '',
      showConfirmBox: false,
      dialogType: type,
    })
    .subscribe((yes) => {
      if (isOK) {
        setTimeout(() => {
          this.router.navigate(['companies']);
        }, 1000);
      }
    });
  }

  EliminarItm(){
    //DELETE
    let msg:string="";
    this.companyService.deleteCompany(this.id)
    .subscribe({
      next: (res) => {
        msg = res.message;
        console.log(msg);
        this.msgDialog(msg, '', true, 'O');
      },
      error: (e) => {
        msg = e.error.message;
        console.error(e);
        this.msgDialog('ERROR', msg, false, 'E');
      },
    });
  }

  onEliminarItm() {
    this.dialogService.confirmDialog({
        title: this.translocoService.translate('company.msgTitle'),
        message: this.translocoService.translate('company.msgMessage'),
        message2: this.translocoService.translate('company.msgMessage2'),
        confirmText: this.translocoService.translate('company.confirmText'),
        cancelText: this.translocoService.translate('company.cancelText'),
        showConfirmBox: true,
        dialogType: 'A',
    })
    .subscribe((yes) => {
      if (yes) {
        this.EliminarItm();
        console.log('Si Eliminar.');
      }
    });
  }


  updateLogo() {
    const inputElement = document.createElement('input');
    inputElement.type = 'file';
    inputElement.accept = '.png';


    inputElement.addEventListener('change', (event: any) => {
      const file = event.target.files[0];

      if (file) {
        const reader = new FileReader();

        this.filename = file.name;

        reader.onload = (readerEvent) => {
          const base64String = readerEvent.target?.result as string;
          this.imageBase64 = base64String.split(',')[1];
          
        };

        reader.readAsDataURL(file);
      }
    });
    inputElement.click()
  }
}
